import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    AddPaymentWidgetWrap: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        fontWeight: "600",
        // width: '70vw',
        "& .AddPaymentWidgetWrap1": {
            // width: '70vw'
        },
    },
    AddPaymentWidget: {
        background: "#f5f6fa",
        // background: "#f5f6fa",
        padding: "17px",
        width: "100%",
        "& .Btn--Primary": {
            background: "#e14954",
            boxShadow:
                "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
            borderRadius: "8px",
            fontWeight: "700",
            fontSize: "12px",
            lineHeight: "15px",
            textAlign: "center",
            textTransform: "uppercase",
            color: "#FFFFFF",
            // boxShadow: 'none',
            border: "none",
            padding: "16px",
            display: "block",
            width: "100%",
            marginTop: "8px",
        },
        "& .AddPaymentWidgetWrap": {
            width: "535px",
        },
        "& .Btn--Primary:hover": {
            cursor: "pointer",
        },
        "& .Btn--Secondary": {
            background: "#e14954",
            boxShadow:
                "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
            borderRadius: "8px",
            fontWeight: "700",
            fontSize: "12px",
            lineHeight: "15px",
            textAlign: "center",
            textTransform: "uppercase",
            color: "#FFFFFF",
            // boxShadow: 'none',
            border: "none",
            padding: "16px",
            display: "block",
            width: "100%",
            cursor: "pointer",
        },
        "& .Btn--Secondary:hover": {
            cursor: "pointer",
        },
    },
    SmallTablePlaceholderWrapper: {
        marginBottom: "20px",
    },
    CurrencyAmount: {
        display: "flex",
        alignItems: "center",
        marginBottom: "20px",
        "& .CurrencyAmount_Currencies": {
            marginRight: "auto",
            display: "flex",
            "& >div": {
                background: "rgba(251, 253, 245, 0.75)",
                padding: "12px",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "12px",
                lineHeight: "15px",
                textTransform: "uppercase",
                color: "#271D1C",
                marginRight: "8px",
            },
        },
        "& .CurrencyAmount_OrderAmount": {
            background: "#e5e9f2",
            borderRadius: "8px",
            padding: "4px 8px",
            "&>div:first-child": {
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "10px",
                lineHeight: "12px",
                textAlign: "center",
                textTransform: "uppercase",
                color: "#6E7187",
            },
            "&>div:last-child": {
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "16px",
                lineHeight: "19px",
                textAlign: "center",
                textTransform: "uppercase",
                color: "#271D1C",
            },
        },
    },
    AmountView: {
        // marginBottom: "20px",
        display: "flex",
        alignItems: "flex-start",
        "& > div": {
            flex: 1,
            "&:first-child": {
                display: "flex",
                flexDirection: "column",
                marginRight: "20px", // Adjust the spacing between the two inputs
                "& > div:first-child": {
                    fontStyle: "normal",
                    fontWeight: 700,
                    fontSize: "14px",
                    lineHeight: "17px",
                    textTransform: "uppercase",
                    color: "#271D1C",
                    // marginBottom: "4px",
                },
                "& > div:last-child": {
                    padding: "15px 24px",
                    background: "rgba(251, 253, 245, 0.75)",
                    border: "1px solid #e5e9f2",
                    fontStyle: "normal",
                    fontWeight: 600,
                    fontSize: "18px",
                    lineHeight: "22px",
                    textTransform: "uppercase",
                    color: "#271D1C",
                },
            },
            "&:last-child": {
                padding: "20px 1px",
                // background: "rgba(251, 253, 245, 0.75)",
                // border: "1px solid #e5e9f2",
                fontStyle: "normal",
                fontWeight: 600,
                fontSize: "18px",
                lineHeight: "22px",
                textTransform: "uppercase",
                color: "#271D1C",
            },
        },
    },
    Keys: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        gridTemplateRows: "1fr 1fr 1fr 1fr",
        gap: "8px 8px",
        marginBottom: "10px",
        width: "270px",
        "& .Number": {
            background: "#6E7187",
            borderRadius: "8px",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: "19px",
            textAlign: "center",
            textTransform: "uppercase",
            color: "#FFFFFF",
            padding: "12px",
            "& img": {
                margin: "0 auto",
            },
        },

        "& .Delete": {
            background: "rgba(251, 253, 245, 0.75)",
            borderRadius: "8px",
            textAlign: "center",
            padding: "12px",
            "& img": {
                margin: "0 auto",
            },
        },
        "& .Clear": {
            background: "rgba(251, 253, 245, 0.75)",
            borderRadius: "8px",
            textAlign: "center",
            padding: "12px",
            textTransform: "uppercase",
            "& img": {
                margin: "0 auto",
            },
        },
    },
    Tips: {
        marginBottom: "20px",
        "& .Tips__Title": {
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "17px",
            textTransform: "uppercase",
            color: "#271D1C",
            marginBottom: "4px",
        },
        "& .Tips__Amounts": {
            display: "flex",
            "& .Number": {
                width: "51px",
                height: "47px",
                background: "#6E7187",
                borderRadius: "8px",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "14px",
                textTransform: "uppercase",
                color: "#FFFFFF",
                textAlign: "center",
                lineHeight: "47px",
                marginRight: "4px",
                cursor: "pointer",
                "&.IsSelected": {
                    background: "rgba(251, 253, 245, 0.75)",
                    color: "#271D1C",
                    border: "1px solid #6E7187",
                },
            },
        },
    },
    Discount: {
        marginBottom: "20px",
        "& .Discount__Title": {
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "17px",
            textTransform: "uppercase",
            color: "#271D1C",
            marginBottom: "4px",
        },
        "& .Discount__Amounts": {
            display: "flex",
            "& .Number": {
                width: "38px",
                height: "32px",
                background: "#6E7187",
                borderRadius: "8px",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "12px",
                textTransform: "uppercase",
                color: "#FFFFFF",
                textAlign: "center",
                lineHeight: "30px",
                marginRight: "4px",
                cursor: "pointer",
                "&.IsSelected": {
                    background: "rgba(251, 253, 245, 0.75)",
                    color: "#271D1C",
                    border: "1px solid #6E7187",
                },
            },
            "&.Disabled": {
                "& .Number": {
                    background: "#dddddd",
                },
            },
            "& .DiscountButton": {
                height: "50px",
                width: "50px",
                lineHeight: "50px",
            },
        },
    },
    PaymentType: {
        marginBottom: "20px",
        display: "flex",
        // alignItems: "center",
        padding: "1px 1px",
        // background: "#E6D0C5",
        // height: "20px",m
        // border: "1px solid #e5e9f2",
        justifyContent: "space-around",
    },
    PaymentType1: {
        marginBottom: "20px",
        // display: "flex",
        alignItems: "center",
        padding: "1px 1px",
        // background: "#e5e9f2",
        // border: "1px solid #e5e9f2",
        justifyContent: "space-around",
    },
    MainContainer: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
    },
    VerticalContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start", // Aligns items to the start of the container
        justifyContent: "flex-start", // Adjusts space distribution along the container's main axis
        width: "100%",
        gap: "5px", // Adds space between the child divs
    },
    Change: {
        // marginBottom: "20px",
        display: "flex",
        alignItems: "center",
        padding: "13px 21px",
        background: "#e5e9f2",
        border: "1px solid #e5e9f2",
        justifyContent: "space-between",
        "& .Change__Title": {
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "15px",
            textTransform: "uppercase",
            color: "#6E7187",
        },
        "& .Change__Amount": {
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "20px",
            lineHeight: "24px",
            textTransform: "uppercase",
            color: "#271D1C",
        },
        "& .Change__Currency": {},
    },
    tableContainer_11: {
        // Add your custom styles here
        // Example:
        backgroundColor: "#f2f2f2",
        borderRadius: "4px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        padding: "1px",
    },
    table: {
        borderSpacing: "10",
        "& td, & th": {
            padding: "6px", // Add padding to the cells as needed
        },
    },
    smallButton: {
        // padding: '4px 4px', // Adjust the padding as needed
        fontSize: "8px", // Adjust the font size as needed
    },
    itemCode: {
        fontWeight: "bold", // Adjust the font weight as needed
    },
    itemAddon: {
        marginLeft: "20px", // Adjust the spacing as needed
        fontSize: "10px",
    },
    OrderItemsBackdrop: {
        position: "absolute",
        backgroundColor: "rgba(33, 43, 54, 0.75)",
    },
}));
